import { useMutation } from '@tanstack/react-query';
import { makeRequest } from '../../data/makeRequest';

type DeleteSurveyInvitationRequest = {
	projectId: number;
	surveyId: string;
};

export const useDeleteSurveyInvitationMutation = () => {
	return useMutation({
		mutationFn: (data: DeleteSurveyInvitationRequest) =>
			makeRequest<{
				deleted: boolean;
			}>({
				method: 'deleteSurveyInvitation',
				service: 'cde',
				data
			})
	});
};
